import * as uuid from 'uuid';
import { ONE_MINUTE_MS } from '../common/constants/time';
export const DUTY_ITEM_STATE_OPEN = 'open';
export const DUTY_ITEM_STATE_FINISHED = 'finished';
export const DUTY_ITEM_TYPE_FLIGHT = 'flight';
export const DUTY_ITEM_TYPE_FLIGHT_NC = 'flight-nc';
export const DUTY_ITEM_TYPE_OTHER_DUTY = 'otherDuty';
export const DUTY_ITEM_TYPE_BREAK = 'break';
export const DUTY_ITEM_TYPE_ACCOMODATION_TRANSPORT = 'accomodationTransport';
export const DUTY_ITEM_TYPE_STANDBY_AIRPORT = 'standby-airport';
export const DUTY_ITEM_TYPE_STANDBY_HOTEL = 'standby-hotel';
export const DUTY_ITEM_TYPE_STANDBY_RESIDENCE = 'standby-residence';
export const DUTY_DAY_OFF = 'day-off';
export const DUTY_REST = 'rest';
export const createNewDutyItem = (user, editableByUserIds) => {
    if (!user.crewId) {
        throw new Error('User is not crew');
    }
    return {
        id: uuid.v4(),
        userId: user.userId,
        crewId: user.crewId,
        state: DUTY_ITEM_STATE_OPEN,
        type: DUTY_ITEM_TYPE_FLIGHT,
        startDate: new Date(),
        endDate: new Date(Date.now() + ONE_MINUTE_MS),
        forceRestAfter: false,
        sectorCount: 0,
        blockTimeMinutes: 0,
        startPlaceIcao: undefined,
        endPlaceIcao: '',
        flightLegIds: [],
        logbookRecordIds: [],
        deleted: false,
        note: null,
        linkedDutyItemIds: [],
        plannedFdpExtension: false,
        editableByUserIds: [...editableByUserIds],
    };
};
//# sourceMappingURL=types.js.map